<form (ngSubmit)="formSubmit()">
  <div class="card text-center">
    <div class="card-header bg-primary text-left text-white font-weight-bold">
      Customer Search
    </div>
    <div class="card-body mat-card">

      <div class="row" *ngIf="FormModel.UserOfficeId != 1">
        <div class="col-sm-12 text-left pb-2">
            <span class="bullHorn"><i class="fa fa-bullhorn fa-lg"></i></span>
            <span class="font-red-flamingo ml-2">
              For DD/DL - FG SPRA , Log the oppotunity first.</span>
          </div>
          </div>

      <div class="row">
        <div class="col-sm-6">
          <div class="form-group row text-left">
            <label for="lblOffice" class="col-sm-4 col-form-label">Office <span
                class="font-red-flamingo">*</span></label>
            <div class="col-sm-8">
              <select id="ddlOffice" name="ddlOffice" [(ngModel)]="FormModel.officeId"
                (ngModelChange)="changeOffice(FormModel.officeId)" class="form-control">
                <option *ngFor="let ol of OfficeList" value={{ol.officeId}}>{{ol.officeDesc}} </option>
              </select>
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group row text-left">
            <label for="lblCustomerName" class="col-sm-4 col-form-label">Company Name</label>
            <div class="col-sm-8">
              <input type="text" id="txtCustomerName" name="txtCustomerName" [(ngModel)]="FormModel.customerName"
                class="form-control">
            </div>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="form-group row text-left">
            <label for="lblSaleCode" class="col-sm-4 col-form-label">Sale Code</label>
            <div class="col-sm-8">
              <input type="text" id="txtSaleCode" name="txtSaleCode" [(ngModel)]="FormModel.saleCode"
                class="form-control">
            </div>
          </div>

        </div>

      </div>

    </div>
    <div class="card-footer text-left">
      <div class="row">
        <div class="col-sm-2"></div>
        <div class="col-sm-6">
          <div class="form-group row">
            <div class="col-sm-10">
              <button type="submit" class="btn btn-primary">Submit</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
</form>